import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const PrimaryMedium = S.PrimaryMediumBase;

PrimaryMedium.displayName = "PrimaryMedium";

PrimaryMedium.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.LIGHT, fontWeightOptions.SEMI_BOLD])
};

PrimaryMedium.defaultProps = {
  weight: fontWeightOptions.LIGHT
};

export default PrimaryMedium;
